import {
  IGooglePayCardParameters,
  IGooglePayIsReadyToPayRequest,
  IGooglePayPaymentDataRequest,
  IGooglePaymentsClient,
  TGooglePayEnvironment,
} from "../types/GooglePay"

const GOOGLE_PAY_SDK_URL = "https://pay.google.com/gp/p/js/pay.js"

let sdkLoadPromise: Promise<void> | null = null

/** Carrega o SDK do Google Pay dinamicamente (mesmo padrão de loadStone3DSSDK). */
export function loadGooglePaySDK(): Promise<void> {
  if (window.google?.payments?.api) return Promise.resolve()
  if (sdkLoadPromise) return sdkLoadPromise

  sdkLoadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script")
    script.src = GOOGLE_PAY_SDK_URL
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      sdkLoadPromise = null
      reject(new Error("Falha ao carregar Google Pay SDK"))
    }
    document.head.appendChild(script)
  })

  return sdkLoadPromise
}

const CARD_PAYMENT_METHOD_PARAMETERS: IGooglePayCardParameters = {
  allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
  allowedCardNetworks: ["VISA", "MASTERCARD"],
}

export const GOOGLE_PAY_READY_TO_PAY_REQUEST: IGooglePayIsReadyToPayRequest = {
  apiVersion: 2,
  apiVersionMinor: 0,
  allowedPaymentMethods: [{ type: "CARD", parameters: CARD_PAYMENT_METHOD_PARAMETERS }],
}

export function buildPagarMePaymentDataRequest({
  gateway = "pagarme",
  gatewayMerchantId,
  googleMerchantId,
  merchantName,
  totalPrice,
  currencyCode,
  countryCode,
}: {
  gateway?: string
  gatewayMerchantId: string
  googleMerchantId?: string
  merchantName: string
  totalPrice: string
  currencyCode: string
  countryCode: string
}): IGooglePayPaymentDataRequest {
  return {
    ...GOOGLE_PAY_READY_TO_PAY_REQUEST,
    merchantInfo: googleMerchantId ? { merchantId: googleMerchantId, merchantName } : { merchantName },
    transactionInfo: { totalPriceStatus: "FINAL", totalPrice, currencyCode, countryCode },
    allowedPaymentMethods: [
      {
        type: "CARD",
        parameters: CARD_PAYMENT_METHOD_PARAMETERS,
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: { gateway, gatewayMerchantId },
        },
      },
    ],
  }
}

export function createGooglePaymentsClient(
  environment: TGooglePayEnvironment,
): IGooglePaymentsClient {
  if (!window.google?.payments?.api) {
    throw new Error("Google Pay SDK não carregado")
  }
  return new window.google.payments.api.PaymentsClient({ environment })
}
